// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomArrowCircleRight = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      opacity: '0.25',
      d: 'M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      opacity: '0.75',
      d: 'M10.7397 16.2799C10.5497 16.2799 10.3597 16.2099 10.2097 16.0599C9.91969 15.7699 9.91969 15.2899 10.2097 14.9999L13.2097 11.9999L10.2097 8.99991C9.91969 8.70991 9.91969 8.22991 10.2097 7.93991C10.4997 7.64991 10.9797 7.64991 11.2697 7.93991L14.7997 11.4699C15.0897 11.7599 15.0897 12.2399 14.7997 12.5299L11.2697 16.0599C11.1197 16.2099 10.9297 16.2799 10.7397 16.2799Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomArrowCircleRight };
